<template>
    <div>
        <p class="mb-0">{{ $t('balance.dateLabel') }}</p>
        <div class="d-flex justify-space-between">
            <kus-base-date-field
                input-class="py-0 pr-3"
                v-for="(date, index) in dates"
                :key="index"
                :disabled="disabled"
                v-model="dates[index]"
                single-line
                hide-details
                :clearable="dates.length > 1"
                @click:clear="removeDate(index)" />

            <template v-if="!disabled">
                <v-btn text icon small @click="addDate" color="primary" class="mt-2">
                    <v-icon small>$vuetify.icons.baseAdd</v-icon>
                </v-btn>
                <v-btn text icon small @click="save" color="primary" class="mt-2">
                    <v-icon small>$vuetify.icons.baseSave</v-icon>
                </v-btn>
            </template>
        </div>
    </div>
</template>

<script>
import KusBaseDateField from '@/modules/base/KusBaseDateField'
import moment from 'moment'

export default {
    name: 'kus-balance-date-selector',
    components: { KusBaseDateField },
    props: {
        value: { type: Array },
        disabled: { type: Boolean }
    },
    computed: {
        dates: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    },
    methods: {

        addDate() {
            this.dates.push(moment().format('YYYY-MM-DD'))
        },

        removeDate(index) {
            this.dates.splice(index, 1)
        },

        save() {
            this.dates.sort()
            this.dates.reverse()
            this.$emit('save', this.dates)
        }
    }
}
</script>
